import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getPaginatedListCatalogs({ search, cancelToken }) {
  let searchCatalog = search.replace('originalCatalog.company_name,', '')
  return axios
    .get(
      `${CATALOGO_ENDPOINT}/${searchCatalog.replace('fields=', 'fields=id,whitoutStock,nuevo,')}`,
      { cancelToken }
    )
    .then(res => res.data)
    .then(paginatedList => {
      paginatedList.data.forEach(row => {
        const brand = row.brand || ''
        row.breadCrumbLabel = `${brand} ${row.model} ${row.version}`
      })
      return paginatedList
    })
}